import { getViewport, getChildSlot } from 'lib-utils'

const logoCarousels = document.querySelectorAll('.js-logo-wall')

const disabledClassName = 'carousel__navigation-button--disabled'

const iconStyle = {
  enabled: {
    textColor: 'var(--nova-brand-light)',
    backgroundColor: 'var(--nova-color-queer-purple)',
  },
  disabled: {
    textColor: 'var(--nova-utility-grey-4)',
    backgroundColor: 'var(--nova-utility-grey-2)',
  },
}

document.addEventListener('DOMContentLoaded', () => {
  if (logoCarousels.length === 0) return

  updateFeaturedSlideAttribute()
  applyStyleToIcon(disabledClassName, iconStyle, logoCarousels)

  window.addEventListener('nova:resize-width', updateFeaturedSlideAttribute)
})

function updateFeaturedSlideAttribute() {
  for (const carousel of logoCarousels) {
    const backgroundColor = carousel.getAttribute('bg-color')
    const viewport = getViewport()

    carousel.style.backgroundColor = 'transparent'
    switch (viewport) {
      case 'small-mobile':
        carousel.setAttribute('slides-per-page', 1.45)
        break
      case 'mobile':
        carousel.setAttribute('slides-per-page', 1.85)
        break
      case 'tablet':
        carousel.setAttribute('slides-per-page', 2.75)
        break
      case 'large-tablet':
        carousel.setAttribute('slides-per-page', 3)
        carousel.style.backgroundColor = backgroundColor
        break
      case 'desktop':
        carousel.setAttribute('slides-per-page', 4)
        carousel.style.backgroundColor = backgroundColor
        break
      default:
        carousel.setAttribute('slides-per-page', 4)
        carousel.style.backgroundColor = backgroundColor
        break
    }
  }
}

function applyStyleToIcon(className, styleObject, carouselElements) {
  for (const carousel of carouselElements) {
    const carouselBtns = carousel.shadowRoot.querySelectorAll(
      '.carousel__navigation-button'
    )

    for (let navigationBtn of carouselBtns) {
      const iconElements = getChildSlot(navigationBtn, '.js-navigation-button')

      for (const iconSvg of iconElements) {
        const strokeColor = navigationBtn.classList.contains(className)
          ? styleObject.disabled.textColor
          : styleObject.enabled.textColor
        const backgroundColor = navigationBtn.classList.contains(className)
          ? styleObject.disabled.backgroundColor
          : styleObject.enabled.backgroundColor

        for (const iconPath of iconSvg.querySelectorAll('path')) {
          iconPath.style.stroke = strokeColor
        }

        navigationBtn.style.backgroundColor = backgroundColor
      }

      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {
            const currentState = mutation.target.classList.contains(className)
            if (navigationBtn !== currentState) {
              navigationBtn = currentState
              applyStyleToIcon(className, styleObject, carouselElements)
            }
          }
        }
      })
      observer.observe(navigationBtn, { attributes: true })
    }
  }
}
